import { getCookieValue } from '@engage/cookies';
import { ENVIRONMENT, FEATURE_TOGGLES, isProdEnv } from '@webtv/env';
/**
 * Can be applied to a feature toggle (i.e. used for all environments), or to an environemnt to be applied only in that environment
 *
 * @example
 * [Feature.Foo]:  { percentage: 50% } // enables the Foo feature for 50% of users in all environments
 * [Feature.Foo]: [Environment.UAT, [Environment.Production, { percentage: 50% }]] // enables the Foo feature for all users in UAT, and for 50% of users in Production
 */

export var OptimizelyFeature;

(function (OptimizelyFeature) {
  OptimizelyFeature["TwoMonthFreeTrialPromo"] = "two-month-free-trial-promo";
  OptimizelyFeature["ProfilePages"] = "profilePages";
  OptimizelyFeature["PrivacyUpdates"] = "privacyUpdates";
})(OptimizelyFeature || (OptimizelyFeature = {}));

export var Feature;

(function (Feature) {
  Feature["Akamai"] = "akamai";
  Feature["Debug"] = "Debug";
  Feature["ReportPerformanceMetrics"] = "report-performance-metrics";
  Feature["OfflineErrorModal"] = "offlineErrorModal";
  Feature["Oauth"] = "oauth";
})(Feature || (Feature = {}));

export var toConfigurationForEnvironment = function toConfigurationForEnvironment(feature) {
  if (typeof feature === 'boolean') {
    return feature; // this is just straight up "on" or "off" for all environments (ezpz)
  } else if (Array.isArray(feature)) {
    // This feature is configured on a per-environment basis
    var environment = feature.find(function (value) {
      return Array.isArray(value) ? value[0] === ENVIRONMENT : value === ENVIRONMENT;
    });

    if (Array.isArray(environment)) {
      // this environment has a configuration
      return environment[1];
    } else if (environment === ENVIRONMENT) {
      // a detailed configuration was not provided, this feature is "on"
      return true;
    } else {
      return false; // this was either misconfigured, or the current environment was not specified (i.e. it's off)
    }
  } else if (typeof feature === 'object') {
    // all environments share the same configuration options
    return feature;
  }

  return false; // we don't know what this is (i.e. it's misconfigured)
};
export var isFeatureEnabled = function isFeatureEnabled(key) {
  var feature = FEATURE_TOGGLES[key];

  if (feature) {
    var configuration = toConfigurationForEnvironment(feature);

    if (!isProdEnv(ENVIRONMENT)) {
      // Check to see if cookie has been set in the QA config tool
      var cookieValue = typeof document === 'undefined' ? null : getCookieValue(key); // If a cookie has been set, it will either be 'true' or 'false'. This should
      // take precedence over the buildtime value

      if (cookieValue) return cookieValue === 'true';
    }

    if (typeof configuration === 'boolean') {
      return configuration;
    }
  }

  return false;
};